// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global Styles */
body {
    font-family: Arial, sans-serif;
    margin: 0;
    padding: 0;
    background-color: #f9f9f9;
  }

  
  /* Section Styling */
  .why-choose-us-main-container-style {
    text-align: center;
    margin-top: 64px;
  }
  
  .heading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px; /* Adjust spacing between line and text */
    margin-bottom: 24px;
}

.green-line {
    width: 30px; /* Adjust width */
    height: 5px; /* Adjust thickness */
    background-color: #008D62; /* Green color */
    border-radius: 5px; /* Rounded edges */
}

.heading-text {
    font-size: 20px;
    font-weight: 600;
    color: #4A4A4A; /* Dark gray color */
    font-family: "Plus Jakarta Sans", sans-serif;
}
  .why-choose-us-main-heading-style {
    font-size: 28px;
    font-weight: 700;
    color: #212529; /* Dark gray color */
    font-family: "Plus Jakarta Sans", sans-serif;
    margin-bottom: 20px;
  }
  
/* Why Choose Us Section */
.why-choose-us-main-features-container-style {
    width: 100%;
    display: flex;
    flex-wrap: wrap; /* Allows items to wrap onto the next line */
    justify-content: center; /* Centers items horizontally */
    gap: 20px; /* Adds space between items */
    padding: 35px; /* Adds spacing inside the section */
}

.why-choose-us-main-feature-card {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    border-radius: 10px;
    width: 600px; /* Fixed width for two items per row */
    transition: transform 0.3s ease-in-out;
}

.why-choose-us-main-feature-card:hover {
  transform: translateY(-5px);
}

  
.why-choose-us-inside-icon-style {
    height: 78px;
    width: 78px;
}

.why-choose-us-inside-title-parent-container {
    margin-left: 32px;
}

.why-choose-us-inside-title-style {
    font-size: 22px;
    font-weight: 700;
    color: #212529;
    font-family: "Plus Jakarta Sans", serif;
    text-align: left;
}

.why-choose-us-inside-description-style {
    font-size: 16px;
    font-weight: 500;
    color: #161C2D;
    font-family: "Plus Jakarta Sans", serif;
    text-align: left;
    width: 360px;
}

  
  /* Responsive Design */
  @media (max-width: 768px) {
    .services-container,
    .features-container {
      flex-direction: column;
      align-items: center;
    }
  
    .service-card,
    .feature-card {
      width: 100%;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/Home/Component/WhyChoose/chooseSection.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;IACI,8BAA8B;IAC9B,SAAS;IACT,UAAU;IACV,yBAAyB;EAC3B;;;EAGA,oBAAoB;EACpB;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS,EAAE,yCAAyC;IACpD,mBAAmB;AACvB;;AAEA;IACI,WAAW,EAAE,iBAAiB;IAC9B,WAAW,EAAE,qBAAqB;IAClC,yBAAyB,EAAE,gBAAgB;IAC3C,kBAAkB,EAAE,kBAAkB;AAC1C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc,EAAE,oBAAoB;IACpC,4CAA4C;AAChD;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc,EAAE,oBAAoB;IACpC,4CAA4C;IAC5C,mBAAmB;EACrB;;AAEF,0BAA0B;AAC1B;IACI,WAAW;IACX,aAAa;IACb,eAAe,EAAE,4CAA4C;IAC7D,uBAAuB,EAAE,+BAA+B;IACxD,SAAS,EAAE,6BAA6B;IACxC,aAAa,EAAE,oCAAoC;AACvD;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY,EAAE,sCAAsC;IACpD,sCAAsC;AAC1C;;AAEA;EACE,2BAA2B;AAC7B;;;AAGA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uCAAuC;IACvC,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uCAAuC;IACvC,gBAAgB;IAChB,YAAY;AAChB;;;EAGE,sBAAsB;EACtB;IACE;;MAEE,sBAAsB;MACtB,mBAAmB;IACrB;;IAEA;;MAEE,WAAW;IACb;EACF","sourcesContent":["/* Global Styles */\nbody {\n    font-family: Arial, sans-serif;\n    margin: 0;\n    padding: 0;\n    background-color: #f9f9f9;\n  }\n\n  \n  /* Section Styling */\n  .why-choose-us-main-container-style {\n    text-align: center;\n    margin-top: 64px;\n  }\n  \n  .heading-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px; /* Adjust spacing between line and text */\n    margin-bottom: 24px;\n}\n\n.green-line {\n    width: 30px; /* Adjust width */\n    height: 5px; /* Adjust thickness */\n    background-color: #008D62; /* Green color */\n    border-radius: 5px; /* Rounded edges */\n}\n\n.heading-text {\n    font-size: 20px;\n    font-weight: 600;\n    color: #4A4A4A; /* Dark gray color */\n    font-family: \"Plus Jakarta Sans\", sans-serif;\n}\n  .why-choose-us-main-heading-style {\n    font-size: 28px;\n    font-weight: 700;\n    color: #212529; /* Dark gray color */\n    font-family: \"Plus Jakarta Sans\", sans-serif;\n    margin-bottom: 20px;\n  }\n  \n/* Why Choose Us Section */\n.why-choose-us-main-features-container-style {\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap; /* Allows items to wrap onto the next line */\n    justify-content: center; /* Centers items horizontally */\n    gap: 20px; /* Adds space between items */\n    padding: 35px; /* Adds spacing inside the section */\n}\n\n.why-choose-us-main-feature-card {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    border-radius: 10px;\n    width: 600px; /* Fixed width for two items per row */\n    transition: transform 0.3s ease-in-out;\n}\n\n.why-choose-us-main-feature-card:hover {\n  transform: translateY(-5px);\n}\n\n  \n.why-choose-us-inside-icon-style {\n    height: 78px;\n    width: 78px;\n}\n\n.why-choose-us-inside-title-parent-container {\n    margin-left: 32px;\n}\n\n.why-choose-us-inside-title-style {\n    font-size: 22px;\n    font-weight: 700;\n    color: #212529;\n    font-family: \"Plus Jakarta Sans\", serif;\n    text-align: left;\n}\n\n.why-choose-us-inside-description-style {\n    font-size: 16px;\n    font-weight: 500;\n    color: #161C2D;\n    font-family: \"Plus Jakarta Sans\", serif;\n    text-align: left;\n    width: 360px;\n}\n\n  \n  /* Responsive Design */\n  @media (max-width: 768px) {\n    .services-container,\n    .features-container {\n      flex-direction: column;\n      align-items: center;\n    }\n  \n    .service-card,\n    .feature-card {\n      width: 100%;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
